import { useEffect, useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { SELECTED_CITY } from "../../../Utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { changeSelectedCity } from "../../../Redux/reducers/selectedCitySlice";
import { fetchRP, setCurrentPage } from "../../../Redux/reducers/recentProduct";

const CityChange = ({ cityOption, pageOffset, width }) => {

    const dispatch = useDispatch();
    const selectedCity = useSelector((state) => state.selectedCity.selectedCity);
    // const currentPage = useSelector((state) => state.recentProducts.currentPage);
    const [isLocationClicked, setLocationClicked] = useState(false);
    const [cityQuery, setCityQuery] = useState('');
    const [offset, setOffset] = useState(0);


    useEffect(() => {
        setOffset(pageOffset);
    }, [pageOffset])

    const selectUserCity = (city) => {
        localStorage.setItem(SELECTED_CITY, JSON.stringify(city));
        window.scrollTo(0, 0);
        dispatch(changeSelectedCity(city));
        dispatch(setCurrentPage(1));
        dispatch(fetchRP({ page: 1, stateChange: true, selectedCity: city }));
    }

    return (
        <>
            <div style={{ top: isLocationClicked ? "15%" : offset < 66 && width < 768 ? 80 - offset : width > 768 ? 80 : 4 }} onClick={() => { setLocationClicked(true); }} className={`cursor-pointer nav-location ${isLocationClicked ? 'clicked' : ''}`}>
                <FaMapMarkerAlt />&nbsp;{selectedCity && <p className={`my-auto d-flex`}>{selectedCity.label.slice(0, 1)}<span className={`d-md-block ${isLocationClicked ? '' : 'd-none'}`}>{selectedCity.label.slice(1)}</span></p>}
            </div>
            <div onClick={() => { setLocationClicked(false); }} className={`loc-overlay ${isLocationClicked ? 'clicked' : ''}`}></div>

            <div className={`col-11 col-sm-10 col-md-8 col-lg-6 loc-dropdown ${isLocationClicked ? 'clicked' : ''}`}>
                <input value={cityQuery} onChange={(e) => { setCityQuery(e.target.value) }} className='loc-input' placeholder="Select your city . . . . ." />
                <div className='loc-options'>
                    <div onClick={() => { selectUserCity({ label: 'All', value: '-1' }); setLocationClicked(false); }} className='loc-option-div'>
                        <p className='loc-option'>All</p>
                    </div>
                    {
                        cityOption && (cityQuery.length > 0 ? [...cityOption.filter((e) => e.label.toLowerCase().includes(cityQuery.toLowerCase()))] : [...cityOption]).map((city, index) => {
                            return (
                                <div onClick={() => { selectUserCity(city); setLocationClicked(false); }} key={index} className='loc-option-div'>
                                    <p className='loc-option'>{city.label}</p>
                                </div>
                            );
                        })
                    }
                </div>
                {/* <div onClick={() => { setLocationClicked(false); }} className='loc-btn'>Done</div> */}
            </div>
        </>
    );
}

export default CityChange;